
































import Component, { mixins } from 'vue-class-component'
import Card from '@/components/Card.vue'
import { TransactionsModule } from '@/store/modules/transactions.module'
import { getModule } from 'vuex-module-decorators'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import NoData from '@/views/app/management/residents/NoData.vue'
import { EResidentStatus, EUserPermissions, IResident } from '@zunta/configurations'
import { User } from '@/classes/User'
import Api from '@/api'
import CollectionOutstandingBalance
  from '@/views/app/management/collections/components/CollectionOutstandingBalance.vue'
import { ResidentPageMixin } from '@/views/app/management/residents/resident-page/ResidentPageMixin'

@Component({
  props: {},
  components: {
    CollectionOutstandingBalance,
    LoaderWrapper,
    Card,
    NoData
  }
})
export default class ResidentAgingWidget extends mixins(ResidentPageMixin) {
  transactionsModuleInstance: TransactionsModule = getModule(TransactionsModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  EResidentStatus: any = EResidentStatus
  EUserPermissions: any = EUserPermissions
  user: User = Api.getUser() as User

  isLoading: boolean = false

  get intervals () {
    return this.$store.state.transactions.transactionIntervals.filter((interval: any) => Number(interval) !== 0)
  }

  get residentOpenBalance () {
    return this.$store.state.resident.openBalance
  }

  get residentId () {
    return this.$route.params.id
  }

  get collectionTasks () {
    return this.$store.state.resident.collectionTasks
  }

  get residentCollectionTask () {
    return this.collectionTasks.find((item: any) => (item.resident as IResident).id === Number(this.residentId))
  }

  mounted () {
    this.fetchData()
    this.$watch('residentId', () => this.fetchData())
  }

  async fetchData () {
    try {
      this.isLoading = true
      await Promise.all([
        this.transactionsModuleInstance.getGroupedPaymentsTotals(this.residentId),
        this.residentModuleInstance.fetchResidentOpenBalance(this.residentId),
        this.residentModuleInstance.fetchCollectionTasksByFilters({
          type: 'all',
          active: true
        })
      ])
    } finally {
      this.isLoading = false
    }
  }

  gotoCollecting () {
    if (this.user.hasPermissionFor(EUserPermissions.REVIEW_COLLECTIONS)) {
      this.$locationManager.rememberAndGoTo({
        name: 'management-collection-resident',
        params: {
          residentId: this.residentId.toString()
        },
        query: {
          type: 'all'
        }
      })
    }
  }
}
